import './axios';
import Axios from "axios";
import cacheWraperAxios from "./extendAxios";
import './token';
cacheWraperAxios(Axios);
